import * as types from './BettingHistoryType'

const initialState = {
    loading: false,
    data: [],
    errors: null
}

export const getBettingHistory = (state = initialState, action) => {
    switch(action.type) {
        case types.GET_BETTING_HISTORY:
            return {
                ...state,
                loading: true
            }
        case types.GET_BETTING_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case types.GET_BETTING_HISTORY_FAILED:
            return {
                ...state,
                loading: false,
                errors: action.payload
            }
        default:
            return state
    }
}